// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__OGL{block-size:var(--pageHeight, 100%);inline-size:100%;overflow:auto;transform:translateZ(0);font-family:"Lufga-Regular";font-weight:400;color:var(--text-standard, #282863);--right-gutter: 48px;--left-gutter: 48px;--max-width: 1300px;--min-width: 845px}.__OGL.LKx57{--right-gutter: 16px;--left-gutter: 16px;--max-width: 100%;--min-width: 0}.__OGL.svJ9q{--right-gutter: 0}.__OGL.iwYyN{--left-gutter: 0}.__OGL.Iu4M9{background:#f4f4f7}.__OGL.zH5h8{background:#f5f7fd}.__OGL.Q0Bgf{display:flex;flex-direction:column}.__OGL.Q0Bgf .xuzsR{overflow-x:hidden;flex:1}.jAyov{background-color:inherit;position:sticky;inset-block-start:0;inline-size:100%;z-index:300}.jAyov.sc5ls{box-shadow:0px 4px 12px rgba(40,40,99,.06)}.lHZEj{box-sizing:border-box;display:flex;flex-direction:column;gap:24px;padding:24px var(--right-gutter) 0 var(--left-gutter);inline-size:100%;max-inline-size:var(--max-width);min-inline-size:var(--min-width);margin:0 auto}.LKx57 .lHZEj{padding-top:16px;gap:12px}.b0LpY:empty{display:none}.xuzsR{box-sizing:border-box;inline-size:100%;max-inline-size:var(--max-width);min-inline-size:var(--min-width);padding:var(--page-content-top, 8px) var(--right-gutter) 48px var(--left-gutter);margin:0 auto}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 40px)`,
	"fontSizeH2": `var(--font-size-h2, 36px)`,
	"fontSizeH3": `var(--font-size-h3, 28px)`,
	"fontSizeH4": `var(--font-size-h4, 24px)`,
	"fontSizeH5": `var(--font-size-h5, 20px)`,
	"fontSizeH6": `var(--font-size-h6, 18px)`,
	"fontSizeP1": `var(--font-size-p1, 14px)`,
	"fontSizeP2": `var(--font-size-p2, 12px)`,
	"fontSizeP3": `var(--font-size-p3, 10px)`,
	"lineHeightH1": `var(--line-height-h1, 56px)`,
	"lineHeightH2": `var(--line-height-h2, 52px)`,
	"lineHeightH3": `var(--line-height-h3, 36px)`,
	"lineHeightH4": `var(--line-height-h4, 34px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 30px)`,
	"lineHeightP1": `var(--line-height-p1, 22px)`,
	"lineHeightP2": `var(--line-height-p2, 16px)`,
	"lineHeightP3": `var(--line-height-p3, 14px)`,
	"page": `300`,
	"popover": `550`,
	"bottomSheet": `100000`,
	"globalLoader": `100001`,
	"nativeSplash": `100002`,
	"root": `__OGL`,
	"mobile": `LKx57`,
	"disableRightGutter": `svJ9q`,
	"disableLeftGutter": `iwYyN`,
	"primarySkin": `Iu4M9`,
	"secondarySkin": `zH5h8`,
	"containedHeight": `Q0Bgf`,
	"content": `xuzsR`,
	"stickyToTop": `jAyov`,
	"isScrolled": `sc5ls`,
	"stickyToTopInner": `lHZEj`,
	"contentHeader": `b0LpY`
};
export default ___CSS_LOADER_EXPORT___;
